/**
 * Vanilla JavaScript Calculator View
 * No React dependencies
 */

/**
 * Internal dependencies
 */
import './view.css';
import Calculator from './components/calculator.js';

document.addEventListener('DOMContentLoaded', () => {
	const calculatorLinks = document.querySelectorAll('.calculator, a[href="#calculator"]');

	if (calculatorLinks && calculatorLinks.length > 0) {
		const calculatorOpenBodyClass = 'calculator-open';
		let calculatorInstance = null;

		// Initialize calculator once
		calculatorInstance = new Calculator();

		for (let i = 0; i < calculatorLinks.length; i++) {
			calculatorLinks[i].addEventListener('click', function (e) {
				e.preventDefault();
				e.target.classList.add('active');
				document.body.classList.add(calculatorOpenBodyClass);

				// Show the calculator
				calculatorInstance.show();
			});
		}

		window.closeCalculator = () => {
			const modal = document.getElementById('calculator-modal');

			if (modal) {
				modal.setAttribute('aria-hidden', 'true');
				modal.classList.add('waiting');
				window.setTimeout(() => {
					document.body.classList.remove(calculatorOpenBodyClass);
					modal.classList.add('hidden');
				}, 350);
			}
		};
	}
});
